import { makeApiUrl, makeHttpClient } from '~/main/factories/http';
import { DeleteOrgUnit as UseCaseRemoteDeleteOrgUnit } from '~/domain/usecases/orgUnit/remote';

import { RemoteDeleteOrgUnit } from '~/data/repository/orgUnit';

export const makeRemoteDeleteOrgUnit = (): UseCaseRemoteDeleteOrgUnit =>
  new RemoteDeleteOrgUnit(makeApiUrl('/orgUnits'), makeHttpClient());
